import * as Immutable from "immutable";
export default class Grantee {
  constructor(grant, grantee, capability) {
    this._value = { grant, grantee, capability };
  }
  get grant() {
    return this._value.grant;
  }
  get grantee() {
    return this._value.grantee;
  }
  get capability() {
    return this._value.capability;
  }
  toBuilder() {
    const { grant, grantee, capability } = this._value;
    return new Builder(Immutable.Map({ grant, grantee, capability }));
  }
  toJSON() {
    const { grant, grantee, capability } = this._value;
    return { grant, grantee, capability };
  }
  static fromJSON(value) {
    const { grant, grantee, capability } = value;
    return Grantee.builder().grant(grant).grantee(grantee).capability(capability).build();
  }
  static builder() {
    return new Builder();
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  grant(value) {
    return new Builder(this.value.set("grant", value));
  }
  grantee(value) {
    return new Builder(this.value.set("grantee", value));
  }
  capability(value) {
    return new Builder(this.value.set("capability", value));
  }
  build() {
    const { grant, grantee, capability } = this.value.toObject();
    return new Grantee(grant, grantee, capability);
  }
}
